module.exports = __webpack_public_path__ + "static/img/b2.6a61e13e.png";